export default {
  SET_PRE_FATURAMENTO(state, payload) {
    state.preFaturamento = payload;
  },
  SET_PRE_FATURAMENTO_INFORMACOES_PROCESSO(state, payload) {
    state.preFaturamento.informacoesProcesso = payload;
  },
  SET_PRE_FATURAMENTO_COMPARATIVO_PRODUTO_INVOICE(state, payload) {
    state.preFaturamento.comparativoProdutoInvoice = payload;
  },
  SET_PRE_FATURAMENTO_COMPARATIVO_PRODUTO_DI(state, payload) {
    state.preFaturamento.comparativoProdutoDI = payload;
  },
  SET_PRE_FATURAMENTO_CUSTOS_EMISSAO_NF(state, payload) {
    state.preFaturamento.custosEmissaoNF = payload;
  },
  SET_PRE_FATURAMENTO_FINANCEIRO_PAGAR(state, payload) {
    state.preFaturamento.financeiroPagar = payload;
  },
  SET_PRE_FATURAMENTO_PRODUTOS_PROCESSO(state, payload) {
    state.preFaturamento.produtosProcesso = payload;
  },
  SET_PRE_FATURAMENTO_EXIBIR(state, payload) {
    state.exibirConferenciaPreFaturamento = payload;
  },
};
